module.exports = __webpack_public_path__ + "static/media/event_platform_logo.e9c1800b.png";